<template>
    <div class="week-product">
        <div style="margin-left: 10px;margin-right: 10px;">
            <div>
                <img style="width:100%;height:63px;font-size: 0px;display: block;" src="https://img.zhujiaxian.com/2024/03/bbd70527f5134bbb821a0f2152cfc6f6.png" alt="" srcset="">
            </div>
            <div style="padding:0px 10px 10px 10px;background:#ffffff;border-radius: 0px 0px 12px 12px;">
                <div>
                    <div style="display: flex; justify-content: space-between;">
                        <img :src="newGoodsList[0].imgUrl" alt="" srcset="" style="width: 47%;margin-right: 15px;"   @click="clickFn(newGoodsList[0].skipId)">
                        <div style="flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
                            <img :src="newGoodsList[1].imgUrl" alt="" style="width:100%;height: 50%;    padding-bottom: 10px;"   @click="clickFn(newGoodsList[1].skipId)">
                            <img :src="newGoodsList[2].imgUrl" alt="" style="width:100%;height: 50%;"   @click="clickFn(newGoodsList[2].skipId)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 好物推荐 -->
        <div style="margin-left: 10px;margin-right: 10px;margin-top:10px;">
            <div>
                <img style="width:100%;height:50px;font-size: 0px;display: block;" src="https://img.zhujiaxian.com/2024/03/403eba4dce564c048a8762612786783a.png" alt="" srcset="">
            </div>
            <div style="padding:0px 10px 10px 10px;background:#ffffff;border-radius: 0px 0px 12px 12px;">
                <div>
                    <div class="Populargoods">
                        <div style="margin-bottom:10px;margin-top: 0px;" v-for="(item,index) in ProdRecommend" :key="index"   @click="clickFn(item.skipId)">
                            <img style="width:100%;height: 115px;display: block;" :src="item.imgUrl" alt="" srcset="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 好物推荐end -->
        <!-- <div class="mytitle">
            <span></span>
            <h3>{{ title }}</h3>
        </div>

        <ul>
            <li v-for="item in newGoodsList" :key="item.id" @click="clickFn(item.id)">
                <img :src="item.list_pic_url" alt="" />
                <p>{{ item.name }}</p>
                <p>{{ item.retail_price }}</p>
            </li>
        </ul> -->
    </div>
</template>

<script>
export default {
    name: 'week-product',
    props: ['newGoodsList','ProdRecommend', 'title'],
    methods: {
        clickFn(id) {
            this.$router.push({ path: '/productDetail', query: { id: id } })
        },
    }
}
</script>

<style lang="less" scoped>
.week-product {
    .mytitle {
        text-align: center;
        font-size: 16px;
        margin-top: 20px;
        position: relative;
        height: 50px;
        span {
            width: 50%;
            height: 2px;
            background-color: #ccc;
            display: inline-block;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        h3 {
            width: 30%;
            background-color: #fff;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
    ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li {
            width: 49%;
            img {
                width: 100%;
            }
            p {
                text-align: center;
                font-size: 16px;
            }
        }
    }
}
</style>